// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/reference_image.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/reference_image.proto.
 */
export const file_vision_assets_v1_reference_image: GenFile = /*@__PURE__*/
  fileDesc("CiZ2aXNpb24vYXNzZXRzL3YxL3JlZmVyZW5jZV9pbWFnZS5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEiswEKDlJlZmVyZW5jZUltYWdlEhAKCGFzc2V0X2lkGAEgASgJEhIKCnByb2plY3RfaWQYAiABKAkSHgoWdXBsb2FkZWRfYnlfYWNjb3VudF9pZBgDIAEoCRIUCgxvcmlnaW5hbF91cmwYBCABKAkSFQoNdGh1bWJuYWlsX3VybBgFIAEoCRIuCgpjcmVhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.assets.v1.ReferenceImage
 */
export type ReferenceImage = Message<"protos.vision.assets.v1.ReferenceImage"> & {
  /**
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string uploaded_by_account_id = 3;
   */
  uploadedByAccountId: string;

  /**
   * @generated from field: string original_url = 4;
   */
  originalUrl: string;

  /**
   * @generated from field: string thumbnail_url = 5;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ReferenceImage.
 * Use `create(ReferenceImageSchema)` to create a new message.
 */
export const ReferenceImageSchema: GenMessage<ReferenceImage> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_reference_image, 0);

